/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PaymentOptions } from './PaymentOptions';
const AccessExpiredParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('access-expired')],
    ['successAt', parsers.moment, 'success_at'],
    ['expiredAt', parsers.moment, 'expired_at'],
    ['paymentOptions', PaymentOptions, 'payment_options'],
]);
export class AccessExpired extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AccessExpiredParser.decode(input).map(res => new AccessExpired(res));
    }
    static unsafeDecode(input) {
        return AccessExpired.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AccessExpiredParser.encode(data);
    }
    static schema() {
        return AccessExpiredParser.schema();
    }
}
